import React from 'react';
import FiltroSellos from '../components/filtroSellos';

const verSellos = () => {
    return (
       <FiltroSellos />
    );
};

export default verSellos;